const API_BASE =
  (process.env.REACT_APP_API_BASE || '').replace(/\/+$/, '');

export const getApiUrl = (path: string) => {
  if (!path.startsWith('/')) {
    return `${API_BASE}/${path}`;
  }
  return `${API_BASE}${path}`;
};
